import { render, staticRenderFns } from "./ModalBlock.vue?vue&type=template&id=2c23f62e"
import script from "./ModalBlock.vue?vue&type=script&lang=js"
export * from "./ModalBlock.vue?vue&type=script&lang=js"
import style0 from "./ModalBlock.vue?vue&type=style&index=0&id=2c23f62e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports